export default function getRecordId() {
	const pathname = window.location.pathname.split('/');
	pathname.reverse();
	const recordId = pathname.includes('detail') && pathname.length > 4 ? pathname[0] : 'newRecord';

	return recordId;
}
